import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { map } from 'rxjs/operators';

export const permissionGuard =
  (requiredPermissions: string[]): CanActivateFn =>
  () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.hasPermission(requiredPermissions).pipe(
      map(hasPermission => {
        if (hasPermission) {
          return true;
        }

        router.navigate(['/unauthorized']);
        return false;
      })
    );
  };
